import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { BLACK_CAKTO, BLACK_CAKTO_ASSETS } from './blackNovemberTheme';

/**
 * A peça premiada: o troféu Black Cakto 100K da comunicação oficial, e não um
 * desenho nosso, para o painel mostrar a mesma peça que o site promete.
 *
 * A faixa usa a versão pequena; o dialog, a grande. A variante `muted` (quem
 * não bateu a meta) sai de um filtro, não de um segundo arquivo.
 */
export default function BlackNovemberAward({ height = 44, large = false, muted = false, title }) {
  return (
    <Box
      component="img"
      src={large ? BLACK_CAKTO_ASSETS.trophyLarge : BLACK_CAKTO_ASSETS.trophySmall}
      alt={title || ''}
      aria-hidden={title ? undefined : true}
      draggable={false}
      sx={{
        display: 'block',
        flexShrink: 0,
        height,
        width: 'auto',
        userSelect: 'none',
        // Acompanha o header que encolhe no scroll.
        transition: 'height .2s',
        // Na faixa o acrílico escuro some contra o fundo, então a versão pequena
        // sai mais clara; no dialog a peça aparece como no site.
        filter: muted
          ? BLACK_CAKTO.mutedFilter
          : `${large ? '' : 'brightness(1.45) '}drop-shadow(0 0 ${
              large ? 24 : 10
            }px rgba(111,191,134,.25))`,
        opacity: muted ? 0.7 : 1,
      }}
    />
  );
}

BlackNovemberAward.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  large: PropTypes.bool,
  muted: PropTypes.bool,
  title: PropTypes.string,
};
